//Effect hook runs one time when component is mounted
import { useEffect } from 'react';

const useOnMount = (onMount: () => void) =>
  useEffect(() => {
    if (onMount) onMount();
  }, []); //eslint-disable-line

export default useOnMount;
